import jsLightbox from "lightbox2/dist/js/lightbox.js";
import cssLightbox from "lightbox2/dist/css/lightbox.css";

const $ = window.jQuery;
export default {
  attach: function (context, settings) {
    const jsLightbox2_once = once('js-lightbox2-once', 'div[data-lightbox][data-href]', context);

    $(jsLightbox2_once).each(function () {
      // Fix for images inside anchors.
      $('div[data-lightbox][data-href]').each(function () {
        if (!$(this).parents('a').length) {
          // When the image is not inside an anchor, wrap it into a lightbox link.
          let $data_href = $(this).attr('data-href');
          let $data_lightbox = $(this).attr('data-lightbox');
          $(this).children().wrapAll('<a href="' + $data_href + '" data-lightbox="' + $data_lightbox + '" />');

          // Remove data parameters from the container.
          $(this).removeAttr('data-href');
          $(this).removeAttr('data-lightbox');
        }
      });

      // lightbox is already initiated at this point due to html, just grab it and update options
      jsLightbox.option({
        'wrapAround': true,
        'showImageNumberLabel': true,
        'albumLabel': 'Bild %1 von %2', // german translation for 'Image 1% of %2'
      });
    });
  }
}
